var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.717,
    height: 40.573,
    viewBox: "0 0 36.717 40.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_metro-security",
    x: 0,
    y: 0,
    width: 36.6,
    height: 40.573,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51226",
    "data-name": "Group 51226",
    transform: "translate(-904.501 -6084.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51227",
    "data-name": "Group 51227",
    transform: "translate(928.549 6094.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10177",
    "data-name": "Rectangle 10177",
    transform: "translate(-0.33 0.428)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 12.5,
    height: 16.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16615",
    "data-name": "Path 16615",
    transform: "translate(1.363 9.121)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16634",
    "data-name": "Path 16634",
    transform: "translate(1.363 5.363)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16635",
    "data-name": "Path 16635",
    transform: "translate(1.363 1.8)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16616",
    "data-name": "Path 16616",
    transform: "translate(1.363 12.475)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_5899",
    "data-name": "Line 5899",
    x2: 5.597,
    transform: "translate(5.17 3.113)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5900",
    "data-name": "Line 5900",
    x2: 5.597,
    transform: "translate(5.17 6.722)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5901",
    "data-name": "Line 5901",
    x2: 5.597,
    transform: "translate(5.17 10.738)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5902",
    "data-name": "Line 5902",
    x2: 5.597,
    transform: "translate(5.17 14.191)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 904.5, 6084.1)",
    filter: "url(#Icon_metro-security)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-security-2",
    "data-name": "Icon metro-security",
    d: "M15.227,3.856l-8.8,3.911v5.867c0,5.432,3.75,10.5,8.8,11.733,5.05-1.237,8.8-6.3,8.8-11.733V7.767Z",
    transform: "translate(3.07 3.69)",
    fill: "#fff",
    stroke: "#2a7b39",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51230",
    "data-name": "Group 51230"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5988",
    "data-name": "Line 5988",
    x2: 3,
    y2: 3,
    transform: "translate(919.219 6103.643)",
    fill: "none",
    stroke: "#2a7b39",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5989",
    "data-name": "Line 5989",
    x1: 4,
    y2: 9,
    transform: "translate(922.219 6097.643)",
    fill: "none",
    stroke: "#2a7b39",
    strokeLinecap: "round",
    strokeWidth: 1.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedIcon);
export default __webpack_public_path__ + "static/media/paused-icon.ea5378c8e22834d3739358b7497596e9.svg";
export { ForwardRef as ReactComponent };